import React from "react";
import DocumentCard from "@components/DocumentCard/DocumentCard";
import { useDownloadCertificate } from "@pages/vessel-management/vessel-status/hooks/useDownloadCertificate";
import { t } from "i18next";
import type { VesselCertificate } from "../VesselCallStatus.types";

const TEST_ID_BASE = "vessel-status-page";
const certificatesTrans = "vessel-call";

interface Props {
  certificates?: VesselCertificate[] | null;
}

const VesselCallCertificates: React.FC<Props> = ({ certificates }) => {
  const { handleDownload, handlePreview } = useDownloadCertificate();

  const validCertificates = certificates?.filter((c): c is VesselCertificate => c !== null) ?? [];

  const isEmpty = validCertificates.length === 0;

  return (
    <div className="mt-6">
      {isEmpty ? (
        <div
          className="text-center text-gray-500 py-8"
          data-testid={`${TEST_ID_BASE}-certificates-empty`}
        >
          {t(`${certificatesTrans}.certificates.empty`)}
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {validCertificates.map(
            (
              {
                certificateUrl,
                certificateDocumentName,
                certificateClassName,
                certificateExpiryDate,
                expiryStatus,
                certificateType,
              },
              idx,
            ) => (
              <div key={`${certificateType}-${idx}`} className="w-full">
                <DocumentCard
                  data-testid={`${TEST_ID_BASE}-certificate-${certificateType}`}
                  title={t(`${certificatesTrans}.certificates.${certificateType}`)}
                  fileName={certificateDocumentName}
                  expiryDate={certificateExpiryDate}
                  expiryStatus={expiryStatus}
                  permanent={!certificateExpiryDate}
                  className={certificateClassName || "-"}
                  onDownload={() =>
                    handleDownload(
                      "certificate",
                      "bff-vessel",
                      certificateUrl,
                      certificateDocumentName,
                    )
                  }
                  onPreview={() => handlePreview("certificate", "bff-vessel", certificateUrl)}
                />
              </div>
            ),
          )}
        </div>
      )}
    </div>
  );
};

export default VesselCallCertificates;
